import { Box, Typography } from '@material-ui/core';
import MemoryIcon from '@material-ui/icons/Memory';
import React, { useMemo } from 'react';
import { Datagrid, FunctionField, List, Record, ReferenceField, TextField, useTranslate } from 'react-admin';
import { extractIdFromURI } from '../../../utils/resources/ids';
import CollapsePanel from '../components/CollapsePanel';
import McConfigMenu from './McConfigMenu';

interface McsPanelProps {
    selected: any;
}

const McsPanel: React.FC<McsPanelProps> = ({ selected }) => {
    const t = useTranslate();

    const selectedId: string | undefined = useMemo(
        () =>
            typeof selected === 'string'
                ? selected
                : selected?.avatarId || selected?.id || selected?.['@id'],
        [selected],
    );
    const avatarId = selectedId ? extractIdFromURI(selectedId) : undefined;

    // Si no hay avatarId, no mostramos el panel
    if (!avatarId) {
        return (
            <CollapsePanel icon={<MemoryIcon fontSize='small' />} title={t('app.objects.mc') || 'MCs'}>
                <Typography variant='body2' color='textSecondary'>
                    {t('app.objects.noNotes') || 'No hay MCs disponibles'}
                </Typography>
            </CollapsePanel>
        );
    }

    return (
        <CollapsePanel icon={<MemoryIcon fontSize='small' />} title={t('app.objects.mc') || 'MCs'}>
            <Box style={{ display: 'grid', width: '100%', overflowX: 'auto' }}>
                <List
                    resource='m_cs'
                    basePath='/m_cs'
                    filter={{
                        avatar: avatarId,
                    }}
                    actions={false}
                    component='div'
                    syncWithLocation={false}
                    perPage={10}
                    bulkActionButtons={false}
                >
                    <Datagrid hover={false}>
                        <FunctionField
                            label={''}
                            render={(record?: Record) => (record ? <McConfigMenu mc={record} /> : null)}
                        />

                        <TextField source='name' label={t('app.mc.name') || 'Nombre'} />

                        <ReferenceField
                            source={'yourls.finger'}
                            reference={'fingers'}
                            label={t('app.objects.service') || 'Servicio'}
                            sortable={false}
                            link={false}
                        >
                            <TextField source='name' />
                        </ReferenceField>
                    </Datagrid>
                </List>
            </Box>
        </CollapsePanel>
    );
};

export default McsPanel;
